import request from '@/config/axios'

export interface MallSearchConfigVO {
  id?: number
  hotKeywords?: string[]
}

export const getMallSearchConfig = async () => {
  return await request.get({ url: `/trade/mall-search-config/get` })
}

export const saveMallSearchConfig = async (data: MallSearchConfigVO) => {
  return await request.put({ url: `/trade/mall-search-config/save`, data })
}
